import { render, staticRenderFns } from "./ApplicantInformations.vue?vue&type=template&id=738254ca&"
import script from "./ApplicantInformations.vue?vue&type=script&lang=js&"
export * from "./ApplicantInformations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports